import {Routes} from '@angular/router';
import {LayoutComponent} from "./layout/layout.component";
import {CallbackComponentComponent} from "./common/components/callback-component/callback-component.component";
import {LoginComponent} from "./common/pages/login/login.component";
import {authGuard} from "./core/guards/auth/auth.guard";
import {EquipmentItemContextService} from "./service/context/equipment-item-context.service";
import {loginGuard} from "./core/guards/loginGuard/loginGuard";
import {accessoryDetailResolver} from './feature/consumable/resolver/accessory-detail.resolver';
import {productDetailResolver} from "./feature/inventory/resolver/product.resolver";
import {inventoryDetailResolver} from "./feature/inventory/resolver/inventory.resolver";
import {StockDetailResolver} from "./feature/inventory/resolver/StockDetailResolver";
import {StockItemDetailResolver} from "./feature/inventory/resolver/stockItemDetailResolver";
import {permissionGuard} from "./core/guards/permission.guard";
import { DocumentService } from './service/document.service';
import { SdrfDocumentService } from './service/sdrf-document.service';
import {landingGuard, welcomeGuard} from './core/guards/landing.guard';

export const routes: Routes = [
  {
    path: 'callback',
    component: CallbackComponentComponent,
  },
  {
    path: 'login',
    component: LoginComponent,
    canActivate: [loginGuard],
  },
  {
    path: '',
    canActivate: [authGuard],
    canActivateChild: [permissionGuard],
    component: LayoutComponent,
    // resolve: {
    //   me: sessionResolver
    // },
    data: {
      breadcrumb: '',
      sidebar: {
        items: [
          {
            label: 'Dashboard',
            icon: 'pi pi-th-large',
            link: '/dashboard',
            permission: ['dashboard.read']
          },
          {
            label: 'Analytic Reports',
            icon: 'pi pi-chart-line',
            link: '/analytic-reports',
            permission: ['analytics.read'],
            requiresHeadquarter: true
          },
          {
            label: 'Vendors',
            icon: 'pi pi-building',
            link: '/vendors',
            permission: ['vendor.read'],
            requiresHeadquarter: true
          },
          // {
          //   label: 'System Users',
          //   icon: 'pi pi-users',
          //   link: '/system-users',
          // },
          {
            label: 'Equipment Category',
            icon: 'pi pi-box',
            link: '/equipments',
            permission: ['product.read']
          },
          {
            label: 'Purchase',
            icon: 'pi pi-shopping-cart',
            link: '/purchase',
            permission: ['purchase.read'],
            requiresHeadquarter: true
          },
          {
            label: 'Issuance',
            icon: 'pi pi-send',
            link: '/issuance',
            permission: ['issuance.read']
            // permission: ['administrator.access']
          },
          {
            label: 'Inventory',
            icon: 'pi pi-tags',
            link: '/inventory',
            permission: ['inventory.read']
          },
          // {
          //   label: 'Maintenance',
          //   icon: 'pi pi-cog',
          //   link: '/maintenance',
          // },
          {
            label: 'Maintenance',
            icon: 'pi pi-cog',
            link: '/app-maintenanceV2',
            permission: ['maintenance.read']
          },
          {
            label: 'Documents',
            icon: 'pi pi-file',
            link: '/documents',
            permission: ['document.read']
            // permission: ['document.read']
          },
        ],
        settingsItems: [
          {
            label: 'My Issuance History',
            link: '/settings/issuance-history',
            icon: 'pi pi-send',
            permission: ['issuanceHistory.read']
          },
          {
            label: 'Audit History',
            link: '/settings/auditHistory',
            icon: 'pi pi-sitemap',
            permission: ['auditHistory.read']
          },
          {
            label: 'Units',
            link: '/settings/location',
            icon: 'pi pi-map-marker',
            permission: ['unit.read']
          },
          {
            label: 'Category Group',
            link: '/settings/category',
            icon: 'pi pi-tags',
            permission: ['category.read']
          },
          {
            label: 'User Groups',
            link: '/settings/group',
            icon: 'pi pi-users',
            permission: ['group.read']
          },
          {
            label: 'Users',
            link: '/settings/users',
            icon: 'pi pi-users',
            permission: ['user.read']
          },
        ],
        sdrfItems: [
          {
            label: 'SDRF Website',
            children: [
              {
                label: 'Documents',
                link: '/sdrf/documents',
                icon: 'pi pi-file',
                permission: ['document.read']
              },
              {
                label: 'Gallery',
                link: '/sdrf/gallery',
                icon: 'pi pi-images',
                permission: ['publicGallery.read']
              },
              {
                label: 'Alerts',
                link: '/sdrf/alerts',
                icon: 'pi pi-bell',
                permission: ['publicAlert.read']
              }
            ]
          }
        ]
      }
    },
    children: [
      { path: '', pathMatch: 'full', canActivate: [landingGuard], children: [] },
      {
        path: 'dashboard',
        loadComponent: () =>
          import('./feature/dashboard/dashboard.component')
            .then(m => m.DashboardComponent),
        title: 'Dashboard',
        data: {breadcrumb: 'Dashboard',permission: ['dashboard.read']}
      },

      {
        path: 'vendors',
        loadComponent: () =>
          import('./feature/vendors/vendor.component')
            .then(m => m.VendorComponent),
        title: 'Vendors',
        data: {
          breadcrumb: 'Vendors',
          permission: ['vendor.read']
        }
      },
      {
        path: 'system-users',
        loadComponent: () =>
          import('./feature/system-users/system-users.component')
            .then(m => m.SystemUsersComponent),
        title: 'System Users',
        data: {breadcrumb: 'System Users',permission: ['systemUser.create']}
      },
      {
        path: 'equipments',
        loadComponent: () =>
          import('./feature/product/product-listing/product-listing.component')
            .then(m => m.ProductListingComponent),
        title: 'Equipments',
        data: {
          breadcrumb: 'Equipment Category',
          permission: ['product.read']
        }
      },
      // {
      //   path: 'equipment-subTypes',
      //   data: {breadcrumb: 'Equipment Sub Types'},
      //   children: [
      //     {
      //       path: '',
      //       loadComponent: () =>
      //         import('./feature/equipment/equipment.component')
      //           .then(m => m.EquipmentComponent),
      //       title: 'Equipment Sub Types',
      //       data: {breadcrumb: ''}
      //     },
      //     {
      //       path: ':equipmentId',
      //       providers: [EquipmentItemContextService],
      //       resolve: {
      //         inventory: () =>
      //           import('./feature/equipment/resolver/equipment.resolver')
      //             .then(m => m.equipmentResolver),
      //         data: () =>
      //           import('./feature/accessories.resolver')
      //             .then(m => m.accessoriesResolver),
      //       },
      //       data: {
      //         breadcrumb: (route: any) => {
      //           return route.data?.inventory?.name || 'Inventory';
      //         },
      //         dynamicBreadcrumb: true,
      //       },
      //       children: [
      //         {
      //           path: '',
      //           loadComponent: () =>
      //             import('./feature/equipment/equipment-detail/equipment-detail.component')
      //               .then(m => m.EquipmentDetailComponent),
      //           title: 'Equipment Detail',
      //           data: {breadcrumb: ''}
      //         },
      //         {
      //           path: 'issuance/add',
      //           loadComponent: () =>
      //             import('./feature/equipment/equipment-detail/equipment-issuance/create-issuance/create-issuance.component')
      //               .then(m => m.CreateIssuanceComponent),
      //           title: 'Issue Inventory',
      //           data: {breadcrumb: 'Issue Inventory'}
      //         },
      //
      //
      //       ]
      //     },
      //   ],
      // },
      {
        path: 'maintenance',
        loadComponent: () =>
          import('./feature/maintenance/maintenance.component')
            .then(m => m.MaintenanceComponent),
        title: 'Maintenance',
        data: {breadcrumb: 'Maintenance', permission: ['maintenance.read']}
      },
      {
        path: 'app-maintenanceV2',
        loadComponent: () =>
          import('./feature/maintenance-V2/maintenanceV2.component')
            .then(m => m.MaintenanceV2),
        title: 'APP Maintenance',
        data: {
          breadcrumb: 'APP Maintenance',
          permission: ['maintenance.read']
        }
      },
      {
        path: 'analytic-reports',
        loadComponent: () =>
          import('./feature/analytics-reports/analytics-reports.component')
            .then(m => m.AnalyticsReportsComponent),
        title: 'Analytic Reports',
        data: {
          breadcrumb: 'Analytic Reports',
          permission: ['analytics.read']
        }
      },
      {
        path: 'purchase',
        data: {
          permission: ['purchase.read']
        },
        children: [
          {
            path: '',
            loadComponent: () =>
              import('./feature/purchase/purchase.component')
                .then(m => m.PurchaseComponent),
            title: 'Purchase',
            data: {
              breadcrumb: 'Purchase',

            }
          },
          {
            path: 'add',
            loadComponent: () =>
              import('./feature/purchase/add-purchase-page/add-purchase-page.component')
                .then(m => m.AddPurchasePageComponent),
            title: 'Add Purchase',
            data: { breadcrumb: 'Add Purchase', permission: ['purchase.create'] }
          }, {
            path: ':id',
            loadComponent: () =>
              import('./feature/purchase/purchase-detail/purchase-detail.component')
                .then(m => m.PurchaseDetailComponent),
            title: 'Purchase Detail',
            data: {
              breadcrumb: (route: any) => {
                return 'Purchase Detail';
              }
            }
          }
        ]
      },
      {
        path: 'consumables',
        data: {breadcrumb: 'Consumables'},
        children: [
          {
            path: '',
            loadComponent: () =>
              import('./feature/purchase/add-purchase-page/add-purchase-page.component')
                .then(m => m.AddPurchasePageComponent),
            title: 'Consumables',
            data: {breadcrumb: ''},
            resolve: {
              data: () =>
                import('./feature/accessories.resolver')
                  .then(m => m.accessoriesResolver),
            }
          },
          {
            path: ':id',
            loadComponent: () =>
              import('./feature/consumable/consumable-detail/consumable-detail.component')
                .then(m => m.ConsumableDetailComponent),
            resolve: {
              accessory: accessoryDetailResolver
            },
            title: 'Consumable Details',
            data: {
              breadcrumb: (route: any) => {
                return route.data?.accessory?.name || 'Detail';
              },
              dynamicBreadcrumb: true,
            }
          }
        ]
      },
      {
        path: 'issuance',
        title: 'Issuance',
        data: {
          breadcrumb: 'Issuance',
          permission: ['issuance.read']
        },
        children: [
          {
            path: '',
            loadComponent: () =>
              import('./feature/equipment/equipment-detail/equipment-issuance/equipment-issuance.component')
                .then(m => m.EquipmentIssuanceComponent),
            title: 'Issuance',
            data: {breadcrumb: ''}
          },
          {
            path: 'add',
            loadComponent: () =>
              import('./feature/equipment/equipment-detail/equipment-issuance/create-issuance/create-issuance.component')
                .then(m => m.CreateIssuanceComponent),
            title: 'Issue Inventory',
            data: {breadcrumb: 'Issue Inventory',permission: ['issuance.create']}
          }
        ]
      },
      {
        path: 'inventory',
        data: {breadcrumb: 'Inventory',
          permission: ['inventory.read']},
        children: [
          {
            path: '',
            loadComponent: () =>
              import('./feature/inventory-v2/inventory-v2.component')
                .then(m => m.InventoryV2Component),
            title: 'Inventory',
            data: {breadcrumb: ''}
          },
          {
            path: ':productId',
            loadComponent: () =>
              import('./feature/inventory-v2/product-detail/product-detail-wrapper/product-detail-wrapper')
                .then(m => m.ProductDetailWrapperComponent),
            title: 'Product Detail',
            resolve: {
              product: productDetailResolver
            },
            data: {
              breadcrumb: (route: any) => route.data?.product?.name || 'Product Detail',
              dynamicBreadcrumb: true
            },
            children: [
              {
                path: '',
                loadComponent: () =>
                  import('./feature/inventory-v2/product-detail/product-detail.component')
                    .then(m => m.ProductDetailComponent),
                data: {breadcrumb: ''}
              },
              {
                path: 'item/:id',
                loadComponent: () =>
                  import('./feature/inventory/inventory-detail-component-v2/inventory-detail-component-v2.component')
                    .then(m => m.InventoryDetailComponentV2Component),
                resolve: {inventory: inventoryDetailResolver},
                data: {
                  breadcrumb: (route: any) => route.data?.inventory?.serialNumber || 'Inventory Item',
                  dynamicBreadcrumb: true
                }
              }
            ]
          },
          // Stock routes
          {
            path: 'stock/:inventoryStockId',
            loadComponent: () =>
              import('./feature/inventory/stock-detail/stock-detail-wrapper/stock-detail-wrapper.component')
                .then(m => m.StockDetailWrapperComponent),
            resolve: {stock: StockDetailResolver},
            data: {
              breadcrumb: (route: any) => {
                const stock = route.data?.stock;
                const productName = stock?.productName || stock?.name || 'Stock Details';
                return `${productName}`;
              },
              dynamicBreadcrumb: true
            },
            children: [
              {
                path: '',
                loadComponent: () =>
                  import('./feature/inventory/stock-detail/stock-detail.component')
                    .then(m => m.StockDetailComponent),
                data: {breadcrumb: ''}
              },
              {
                path: 'item/:id',
                loadComponent: () =>
                  import('./feature/inventory/stock-detail/stock-item-detail/stock-item-detail.component')
                    .then(m => m.StockItemDetailComponent),
                resolve: {inventory: StockItemDetailResolver},
                data: {
                  breadcrumb: (route: any) => route.data?.inventory?.totalQuantity || 'Inventory Item',
                  dynamicBreadcrumb: true
                }
              }
            ]
          }
        ]
      },
      {
        path: 'documents',
        title: 'Documents',
        data: {
          breadcrumb: 'Documents',
          permission: ['document.read']
          // permission: ["document.read"]
        },
        children: [
          {
            path: '',
            loadComponent: () =>
              import('./feature/documents/documents.component')
                .then(m => m.DocumentsComponent),
            data: {breadcrumb: ''}
          },
          {
            path: ':id',
            loadComponent: () =>
              import('./feature/documents/document-viewer/document-viewer.component')
                .then(m => m.DocumentViewerComponent),
            title: 'Document Detail',
            data: {
              breadcrumb: (route: any) => route.data?.document?.documentName || 'Document Detail',
              dynamicBreadcrumb: true
            }
          }
        ]
      },
      {
        path: 'sdrf/gallery',
        data: { breadcrumb: 'SDRF Gallery',permission: ['publicGallery.read'] },
        children: [
          {
            path: '',
            loadComponent: () =>
              import('./feature/gallery/gallery.component')
                .then(m => m.GalleryComponent),
            title: 'SDRF Gallery',
            data: {
              breadcrumb: 'Gallery',
              isSdrf: true
            }
          },
          {
            path: ':id',
            loadComponent: () =>
              import('./feature/gallery/gallery-viewer/gallery-viewer.component')
                .then(m => m.GalleryViewerComponent),
            title: 'SDRF Gallery Item Detail',
            data: {
              breadcrumb: (route: any) => route.data?.galleryItem?.documentName || 'Gallery Item Detail',
              dynamicBreadcrumb: true,
              isSdrf: true
            }
          }
        ]
      },
      {
        path: 'sdrf/documents',
        data: { breadcrumb: 'SDRF Documents', permission: ['document.read']  },
        children: [
          {
            path: '',
            loadComponent: () =>
              import('./feature/documents/documents.component')
                .then(m => m.DocumentsComponent),
            providers: [
              { provide: DocumentService, useClass: SdrfDocumentService }
            ],
            title: 'SDRF Documents',
            data: {
              breadcrumb: 'Documents',
              isSdrf: true
            }
          },
          {
            path: ':id',
            loadComponent: () =>
              import('./feature/documents/document-viewer/document-viewer.component')
                .then(m => m.DocumentViewerComponent),
            providers: [
              { provide: DocumentService, useClass: SdrfDocumentService }
            ],
            title: 'SDRF Document Detail',
            data: {
              breadcrumb: (route: any) => route.data?.document?.documentName || 'Document Detail',
              dynamicBreadcrumb: true,
              isSdrf: true
            }
          }
        ]
      },
      {
        path: 'sdrf/alerts',
        loadComponent: () =>
          import('./feature/sdrf-alerts/sdrf-alerts.component')
            .then(m => m.SdrfAlertsComponent),
        title: 'SDRF Alerts',
        data: { breadcrumb: 'Alerts' }
      },
      {
        path: 'settings',
        title: 'Settings',
        loadChildren: () =>
          import('./feature/settings/settings.routes').then(
            (m) => m.SETTINGS_ROUTES
          ),
      },
      {
        path: 'unauthorized',
        title: 'UnAuthorized',
        loadComponent: () =>
          import('./common/pages/unauthorized/unauthorized.component')
            .then(m => m.UnauthorizedComponent),
      },

      {
        path: 'welcome',
        canActivate: [welcomeGuard],
        loadComponent: () =>
          import('./common/pages/welcome/welcome.component').then(m => m.WelcomeComponent),
        title: 'Welcome',
        data: {breadcrumb: ''}
      },
    ],
  },
];
